module.exports = __webpack_public_path__ + "static/media/tracking3.7f9a477b.png";